/* eslint-disable react/destructuring-assignment */
import { Dialog } from "primereact";
import React, { useContext, useState, createContext } from "react";
import ButtonComponent from "../../presentation/components/button";
import { theme } from "../../presentation/styles/theme";

export const DialogContext: any = createContext(null);

type DialogProps = {
  show: boolean;
  message?: string;
  header?: string;
};

const DialogProvider = (props: any): JSX.Element => {
  const [options, setOptions] = useState<DialogProps>();

  const closeDialog = (): void => {
    setOptions(() => ({ show: false }));
  };

  const handleDialog = (values: any): void => {
    closeDialog();
    setOptions(() => ({ ...values }));
  };

  const onHide = (): void => {
    setOptions({ show: false });
  };

  const renderFooter = (): JSX.Element => (
    <div className="d-flex justify-content-center">
      <ButtonComponent
        type="button"
        title="Ok"
        color={theme.colors.white}
        backgroundColor={theme.colors.primary}
        onClick={() => onHide()}
      />
    </div>
  );

  return (
    <DialogContext.Provider
      value={{
        options,
        handleDialog,
        closeDialog,
      }}>
      {props.children}
      {options?.show && (
        <Dialog
          header={options?.header}
          visible={options?.show}
          position="center"
          modal
          onHide={() => console.log("displayPosition")}
          style={{ width: "30%" }}
          draggable={false}
          resizable={false}
          footer={renderFooter()}>
          <p className="m-0 text-center">{options?.message}</p>
        </Dialog>
      )}
    </DialogContext.Provider>
  );
};

export const useDialog = (): any => {
  const context: any = useContext(DialogContext);
  if (!context) {
    throw new Error("useModal must be used within a provider DialogProvider");
  }

  return { ...context };
};

export default DialogProvider;
